import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment'

import EventModel, { EventStatus } from '@/core/models/Event'
import { TABLES_ALL } from '@/core/models/Room'


@Component
export default class CallsList extends Vue {
  public EventStatus: any = EventStatus

  @Prop({ required: true })
  public calls: Array<any>


  public getFormattedDate (isoDate: string) {
    const date = new Date(isoDate)
    const thisDayDate = new Date(this.$route.params.date)
    return date.toLocaleDateString() !== thisDayDate.toLocaleDateString()
      ? date.toLocaleString()
      : date.toLocaleTimeString()
  }

  public getDateTitle (): string {
    const routeDate = new Date(this.$route.params.date)
    return moment(routeDate.toISOString()).format('LL')
  }

  public getTablesNumbers (event: any): string {
    if (event.table_numbers === 'all') {
      return TABLES_ALL
    }
    return event.tables_name + ': ' + event.table_numbers
  }

  public getRoomOptions (event: any): string {
    return event.options
      ? event.options.map((row: any) => row.name)
      : []
  }

  public gotoCall (callId: string) {
    this.$router.push({ name: 'showCall', params: { id: callId } })
  }
}
